module.exports = __webpack_public_path__ + "static/media/gey.eef4f360.ogg";